<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Promotion code management for all province</h1>
    <promotionListTable  />
  </v-card>
</template>

<script>
import promotionListTable from "@/components/back-office/PromotionAllProvince/PromotionListTable.vue";
export default {
  data() {
    return {};
  },
  components: {
    promotionListTable,
  },

  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Food delivery",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/food/promotion",
      },
      {
        text: "Promotion management",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  methods: {
    async initialize() {},
  },
};
</script>

<style>
</style>
